import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

const SearchableSelect = ({ 
  value, 
  onValueChange, 
  placeholder, 
  userItems = [], 
  companyItems = [], 
  className,
  disabled = false 
}) => {
  const [open, setOpen] = useState(false);

  const allItems = [...userItems, ...companyItems];
  const selectedItem = allItems.find(item => item.name === value || item === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("w-full justify-between", className)}
          disabled={disabled}
        >
          {selectedItem ? (typeof selectedItem === 'string' ? selectedItem : selectedItem.name) : placeholder}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0">
        <Command>
          <CommandInput placeholder={`Search ${placeholder.toLowerCase()}...`} />
          <CommandList>
            <CommandEmpty>No items found.</CommandEmpty>
            
            {userItems.length > 0 && (
              <CommandGroup heading="User Categories">
                {userItems.map((item, index) => (
                  <CommandItem
                    key={`user-${index}`}
                    value={typeof item === 'string' ? item : item.name}
                    onSelect={(currentValue) => {
                      onValueChange(currentValue === value ? "" : currentValue);
                      setOpen(false);
                    }}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        value === (typeof item === 'string' ? item : item.name) ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {typeof item === 'string' ? item : item.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            
            {userItems.length > 0 && companyItems.length > 0 && <CommandSeparator />}
            
            {companyItems.length > 0 && (
              <CommandGroup heading="Company Categories">
                {companyItems.map((item, index) => (
                  <CommandItem
                    key={`company-${index}`}
                    value={typeof item === 'string' ? item : item.name}
                    onSelect={(currentValue) => {
                      onValueChange(currentValue === value ? "" : currentValue);
                      setOpen(false);
                    }}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        value === (typeof item === 'string' ? item : item.name) ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {typeof item === 'string' ? item : item.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SearchableSelect;